import { Type, type Static } from "@sinclair/typebox";
import { MatrixEventIdSchema } from "./agent-host.ts";

const ExcelExpertActivityEventBase = {
  version: Type.Literal("1.0"),
  sourceEventId: MatrixEventIdSchema,
  sequence: Type.Integer({ minimum: 1, maximum: 1_000_000 }),
  text: Type.String({ minLength: 1, maxLength: 256 })
};

export const ExcelExpertActivityPhaseSchema = Type.Union([
  Type.Literal("locating_workbook"),
  Type.Literal("inspecting_workbook"),
  Type.Literal("reading_workbook"),
  Type.Literal("editing_workbook"),
  Type.Literal("verifying_workbook"),
  Type.Literal("finalizing")
]);

export const ExcelExpertProgressEventSchema = Type.Object(
  {
    ...ExcelExpertActivityEventBase,
    type: Type.Literal("progress"),
    phase: ExcelExpertActivityPhaseSchema
  },
  { additionalProperties: false }
);

export const ExcelExpertToolEventSchema = Type.Object(
  {
    ...ExcelExpertActivityEventBase,
    type: Type.Literal("tool"),
    activityId: Type.String({
      minLength: 1,
      maxLength: 128,
      pattern: "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
    }),
    tool: Type.String({ minLength: 1, maxLength: 64, pattern: "^[A-Za-z][A-Za-z0-9_]*$" }),
    status: Type.Union([
      Type.Literal("selected"),
      Type.Literal("started"),
      Type.Literal("completed"),
      Type.Literal("failed")
    ]),
    detail: Type.Optional(Type.String({ minLength: 1, maxLength: 256 })),
    durationMs: Type.Optional(Type.Integer({ minimum: 0, maximum: 300_000 }))
  },
  { additionalProperties: false }
);

export const ExcelExpertActivityEventSchema = Type.Union([
  ExcelExpertProgressEventSchema,
  ExcelExpertToolEventSchema
]);

export const ExcelExpertActivitySummarySchema = Type.Object(
  { events: Type.Array(ExcelExpertActivityEventSchema, { maxItems: 64 }) },
  { additionalProperties: false }
);

export type ExcelExpertActivityPhaseV1 = Static<typeof ExcelExpertActivityPhaseSchema>;
export type ExcelExpertProgressEventV1 = Static<typeof ExcelExpertProgressEventSchema>;
export type ExcelExpertToolEventV1 = Static<typeof ExcelExpertToolEventSchema>;
export type ExcelExpertActivityEventV1 = Static<typeof ExcelExpertActivityEventSchema>;
export type ExcelExpertActivitySummaryV1 = Static<typeof ExcelExpertActivitySummarySchema>;
